import { CountryType } from '@/types/common'

export interface Passport {
	id: number | null
	type: TravelerDocumentType.Passport
	passport_number: string
	issuing_country: CountryType
	citizenship: CountryType
	issue_date: string | null
	expiration_date: string | null
}

export interface NationalId {
	id: number | null
	type: TravelerDocumentType.National_ID
	number: string
	country: CountryType
	expiration_date: string | null
	foid?: boolean
}

// eslint-disable-next-line no-restricted-syntax
export enum TravelerDocumentType {
	Passport = 'passport',
	National_ID = 'national_id',
}
